import { render } from "./App.vue?vue&type=template&id=df1a12c0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=df1a12c0&lang=css"

import exportComponent from "C:\\Users\\marco\\Documents\\src\\steam-what-to-play-together\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__